import { Capacitor } from '@capacitor/core';

export function detectPlatform(capacitor = Capacitor) {
  const isNative = Boolean(capacitor?.isNativePlatform?.());
  const nativeKind = isNative ? String(capacitor?.getPlatform?.() || '').toLowerCase() : '';
  const isAndroid = isNative && nativeKind === 'android';

  return Object.freeze({
    kind: isNative ? (isAndroid ? 'android' : 'native') : 'web',
    isWeb: !isNative,
    isNative,
    isAndroid,
  });
}

export const platform = detectPlatform();

export function shouldPresentPwaInstall({ isInstalled = false } = {}) {
  return platform.isWeb && !isInstalled;
}
